import AbstractAuthenticatedService from '@vertical-plus/vue-js-micro-service-components/lib/model/service/abstract-authenticated-service';
import FormFieldInterface from '@vertical-plus/vue-js-components/lib/model/vos/form/form-field-interface';
import GetInvoiceTask from '@/model/task/billing/get-invoice-task';
import GetInvoicesTask from '@/model/task/billing/get-invoices-task';
import Invoice from '@/model/entity/billing/invoice';
import InvoiceSearchConditionsInterface from '@/model/vo/billing/invoice-search-conditions-interface';
import InvoiceSearchResultsVo from '@/model/vo/billing/invoice-search-results-vo';
import PatchInvoiceTask from '@/model/task/billing/patch-invoice-task';
import PostInvoiceTask from '@/model/task/billing/post-invoice-task';

export default class InvoiceService extends AbstractAuthenticatedService
{
    public static paymentTermsOptions: FormFieldInterface['options'] = [
        {
            value: 'Due for immediate payment',
            title: 'Due for immediate payment',
        },
        {
            value: 'Due on receipt',
            title: 'Due on receipt',
        },
        {
            value: 'Net 7 days',
            title: 'Next 7 days',
        },
        {
            value: 'Net 10 days',
            title: 'Next 10 days',
        },
        {
            value: 'Net 14 days',
            title: 'Next 14 days',
        },
        {
            value: 'Net 30 days',
            title: 'Next 30 days',
        },
        {
            value: 'By direct debit',
            title: 'By direct debit',
        },
        {
            value: 'By standing order',
            title: 'By standing order',
        },
    ];

    /**
     * Returns matching invoices
     *
     * @returns
     */

    public async findInvoices(searchConditions?: InvoiceSearchConditionsInterface): Promise<InvoiceSearchResultsVo>
    {
        const task = new GetInvoicesTask();
        task.token = this.token;
        task.searchConditions = searchConditions;

        return this.runTask(task) as Promise<InvoiceSearchResultsVo>;
    }

    /**
     * Loads a invoice
     *
     * @param id
     * @returns
     */

    public async loadInvoice(id: string): Promise<Invoice>
    {
        const task = new GetInvoiceTask();
        task.token = this.token;
        task.id = id;

        return this.runTask(task) as Promise<Invoice>;
    }

    /**
     * Creates a invoice
     *
     * @param invoice
     * @returns
     */

    public async createInvoice(invoice: Invoice): Promise<Invoice>
    {
        const task = new PostInvoiceTask();
        task.token = this.token;
        task.invoice = invoice;

        return this.runTask(task) as Promise<Invoice>;
    }

    /**
     * Updates a invoice
     *
     * @param invoice
     * @returns
     */

    public async updateInvoice(invoice: Invoice): Promise<Invoice>
    {
        const task = new PatchInvoiceTask();
        task.token = this.token;
        task.invoice = invoice;

        return this.runTask(task) as Promise<Invoice>;
    }
}